// extracted by mini-css-extract-plugin
export default {"root":"IconPeople_root__QEV+6"};